import { put, takeLatest } from 'redux-saga/effects';
import takeRequest from '~/store/takeRequest';
import * as SettingsActions from './actions';

function* reloadAreas(): Generator {
  yield put(SettingsActions.getDistributionAreas.start());
}

function* reloadAgents(): Generator {
  yield put(SettingsActions.getDistributionAgents.start({ page: 0, size: 10 }));
  yield put(SettingsActions.getDistributionFilterOptions.start());
}

export function* settingsSaga(): Generator {
  yield takeRequest(SettingsActions.getAllResolvingAreas);
  yield takeRequest(SettingsActions.getDistributionAreas);
  yield takeRequest(SettingsActions.createDistributionArea);
  yield takeRequest(SettingsActions.updateDistributionArea);
  yield takeRequest(SettingsActions.deleteDistributionArea);
  yield takeRequest(SettingsActions.getDistributionTeams);
  yield takeRequest(SettingsActions.getDistributionAgents);
  yield takeRequest(SettingsActions.getDistributionFilterOptions);
  yield takeRequest(SettingsActions.getAllDistributionAgentEmails);
  yield takeRequest(SettingsActions.searchTelliResponsibles);
  yield takeRequest(SettingsActions.createDistributionAgent);
  yield takeRequest(SettingsActions.findAgentByEmail);
  yield takeRequest(SettingsActions.enableDistributionAgent);
  yield takeRequest(SettingsActions.updateAgent);
  yield takeRequest(SettingsActions.updateAgentFlag);
  yield takeRequest(SettingsActions.removeDistributionAgent);
  yield takeRequest(SettingsActions.getAuditLogs);
  yield takeRequest(SettingsActions.getAuditLogFilters);
  yield takeRequest(SettingsActions.getDistributionFlagOptions);
  yield takeRequest(SettingsActions.getLinkedAgents);

  yield takeLatest(SettingsActions.createDistributionArea.success.toString(), reloadAreas);
  yield takeLatest(SettingsActions.updateDistributionArea.success.toString(), reloadAreas);
  yield takeLatest(SettingsActions.deleteDistributionArea.success.toString(), reloadAreas);
  yield takeLatest(SettingsActions.createDistributionAgent.success.toString(), reloadAgents);
  yield takeLatest(SettingsActions.enableDistributionAgent.success.toString(), reloadAgents);
  yield takeLatest(SettingsActions.updateAgent.success.toString(), reloadAgents);
  yield takeLatest(SettingsActions.updateAgentFlag.success.toString(), reloadAgents);
  yield takeLatest(SettingsActions.removeDistributionAgent.success.toString(), reloadAgents);
}
